module.exports = __webpack_public_path__ + "img/wifi.2603ea10.png";